import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "user-management-container"
};
const _hoisted_2 = {
  class: "logo"
};
import { useSettingsStore } from '@/store/modules/settings';
import getPageTitle from '@/utils/pageTitle';

import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/index';
import 'element-plus/es/components/message/style/index';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      locale
    } = useI18n();
    const route = useRoute();
    const dialogVisible = ref(false);
    const settingsStore = useSettingsStore();
    const {
      theme
    } = storeToRefs(settingsStore);
    const {
      changeLanguage
    } = settingsStore;
    const handleCommand = language => {
      changeLanguage(language);
      locale.value = language;
      document.title = getPageTitle(route.meta.title);
    };
    function toHelper() {
      ElMessage.success('正在接入中');
    }
    function about() {
      dialogVisible.value = true;
    }
    return (_ctx, _cache) => {
      const _component_vab_icon = _resolveComponent("vab-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_unref(theme).showLanguage ? (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 0,
        onCommand: handleCommand
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            onClick: _cache[0] || (_cache[0] = $event => toHelper())
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("帮助中心", -1)]))]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: _cache[1] || (_cache[1] = $event => about())
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("关于", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_vab_icon, {
          icon: "question-line"
        })]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: "",
        width: "500",
        "align-center": ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_image, {
          style: {
            "width": "250px"
          },
          src: "/logo-full.jpg"
        })]), _cache[5] || (_cache[5] = _createElementVNode("div", null, "电话：86088288", -1))])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
});